﻿; (function () {
    const requiredControlEls = Array.from(document.querySelectorAll('[data-val-required]'));
    const ia = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting) {
            entry.target.scrollIntoView();
        }
        ia.unobserve(entry.target);
    });
    const mo = new MutationObserver((mutations) => {
        for (let i = 0; i < mutations.length; i++) {
            const mutation = mutations[i];
            if (mutation.attributeName === 'class' && mutation.target.classList.contains('input-validation-error')) {
                ia.observe(mutation.target);
                break;
            }
        }
    });
    requiredControlEls.forEach(requiredControlEl => {
        mo.observe(requiredControlEl, {
            attributes: true
        });
    });
})();